__turbopack_context__.v({
  "animate": "RegionalSpecialtiesSection-module-scss-module__EkpMka__animate",
  "wiggleContainer": "RegionalSpecialtiesSection-module-scss-module__EkpMka__wiggleContainer",
  "wiggleHint": "RegionalSpecialtiesSection-module-scss-module__EkpMka__wiggleHint",
});
